import React, { useState } from "react";
import { Tabs, Card, Button, Tooltip } from "antd";
import { FilterOutlined } from "@ant-design/icons";

const StatisticsPage = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const TabContent = ({ title, description, chart }) => (
    <Card className="w-full">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-gray-500">{description}</p>
        </div>
        <Tooltip title="Filter">
          <Button icon={<FilterOutlined />} />
        </Tooltip>
      </div>
      <div className="h-64">{chart}</div>
    </Card>
  );

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="bg-white p-4 rounded-lg shadow"
          items={[
            {
              key: "overview",
              label: "Overview",
              children: (
                <TabContent
                  title="Total Overview"
                  description="Monthly statistics overview"
                />
              ),
            },
            {
              key: "agents",
              label: "Agents",
              children: (
                <TabContent
                  title="Agent Performance"
                  description="Top performing agents"
                />
              ),
            },
            {
              key: "infractions",
              label: "Infractions",
              children: (
                <TabContent
                  title="Infractions Overview"
                  description="Monthly infraction statistics"
                  chart={
                    <div className="flex items-center justify-center h-full">
                      Infractions chart placeholder
                    </div>
                  }
                />
              ),
            },
            {
              key: "payments",
              label: "Payments",
              children: (
                <TabContent
                  title="Payment Statistics"
                  description="Monthly payment overview"
                  chart={
                    <div className="flex items-center justify-center h-full">
                      Payments chart placeholder
                    </div>
                  }
                />
              ),
            },
            {
              key: "zones",
              label: "Zones",
              children: (
                <TabContent
                  title="Zone Activity"
                  description="Activity by zone"
                  chart={
                    <div className="flex items-center justify-center h-full">
                      Zones chart placeholder
                    </div>
                  }
                />
              ),
            },
          ]}
        />
      </main>
    </div>
  );
};

export default StatisticsPage;
